<template>
  <div class="container py-4">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
        <h1 class="h5 mb-1">Hi, {{ profile.firstname }}</h1>
        <p class="grey">Enter license plate number to start tire report.</p>
        <hr>
        <form v-on:submit.stop.prevent="submit">
          <div class="form-group mb-3">
            <label>License plate</label>
            <input
              v-model.trim="registrationNumber"
              type="text"
              class="form-control form-control-lg text-uppercase font-weight-bold"
              autofocus="true"
              id
            />
            <small v-if="regnoError" class="help-text text-danger">
              <i class="far fa-exclamation-triangle mr-1"></i>Trailer not found.
              Please double-check license plate number.
            </small>
          </div>
          <button
            type="submit"
            :disabled="!canSubmit"
            class="btn btn-info btn-lg btn-block"
          >Start tire report</button>
        </form>
        <span v-if="incompleteReports.length > 0">
          <hr class="mt-4">
          <p class="text-uppercase small grey mt-4 mb-1">Incomplete tire reports on this device</p>
          <div class="list-group">
            <router-link v-for="report in incompleteReports" :key="report.tireReportId"  :to="{ name: 'trailer', params: { id: report.tireReportId } }" class="list-group-item">
              {{report.registrationNumber}}
              <i class="fal fa-chevron-right float-right ml-3 mt-1 grey"></i>
              <small class="float-right mt-1 grey">{{report.startedAt | relativeDate}}</small>
            </router-link>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { getIncompleteReports } from "../lib/incompletereports"

export default {
  metaInfo: {
    title: "Start"
  },
  data: () => ({
    incompleteReports: [],
    registrationNumber: null
  }),
  watch: {
    registrationNumber() {
      if (this.regnoError) this.setRegnoError(false);
    }
  },
  computed: {
    ...mapGetters("user", ["profile"]),
    ...mapState("tireReports", ["regnoError"]),
    canSubmit(){
      return this.registrationNumber && this.registrationNumber.length > 2
    }
  },
  mounted() {
    this.$store.dispatch("user/loadUser");
  },
  methods: {
    ...mapActions("tireReports", ["startTireReport", "setRegnoError", "resetState"]),
    submit() {
      if (this.canSubmit) this.startTireReport(this.registrationNumber)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.incompleteReports = getIncompleteReports();
      vm.resetState()
    })
  },
};
</script>
